module.exports = __webpack_public_path__ + "6aec86b8a37a397104f6749f5b568a2d.svg";